import getModalActions from '../../../shared/modals/getModalActions';
import { ModalNames } from '../../../provisionPage/constants';

export const {
  showAction: showJobErrorsModal,
  hideAction: hideJobErrorsModal,
} = getModalActions(ModalNames.JobErrors);
